import React from "react";
import ReactDOM from "react-dom";

import { ConfirmDialog } from "components/Dialog";

const confirm = (action, Component, info) => {
  const wrapper = document.createElement("div");
  const unmount = () => {
    ReactDOM.unmountComponentAtNode(wrapper);
    setTimeout(() => wrapper.parentNode && wrapper.parentNode.removeChild(wrapper));
  };
  const onConfirm = (res) => {
    unmount();

    return action(res);
  };

  const content =
    typeof Component === "string" ? (
      <ConfirmDialog info={info} onCancel={unmount} onConfirm={onConfirm}>
        {Component}
      </ConfirmDialog>
    ) : (
      <Component onCancel={unmount} onConfirm={onConfirm} />
    );

  ReactDOM.render(content, wrapper);
};

export default confirm;
